import omit from 'lodash/omit';

export const types = {
  UpdateFormData: 'UPDATE_FORM_DATA',
  ResetFormData: 'RESET_FORM_DATA',
};

export const initialPageState = {
  placeholderTitle: '',
  userTitle: '',
  mcqLength: 0,
  frqLength: 0,
  excludeInterval: 0,
  masterSubjectId: null,
  number: 1,
  buckets: [],
};

export const pageReducer = (state, action) => {
  const { payload, type } = action;

  switch (type) {
    case types.UpdateFormData:
      return {
        ...state,
        ...payload,
      };
    case types.ResetFormData:
      return {
        ...state,
        ...omit(initialPageState, [
          'masterSubjectId',
          'buckets',
          'placeholderTitle',
        ]),
      };
    default:
      throw Error(`${type} is not a valid action type.`);
  }
};
